import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ca from './locales/ca.json';
import es from './locales/es.json';
import eu from './locales/eu.json';
import gl from './locales/gl.json';

const resources = {
  ca: { translation: ca },
  es: { translation: es },
  eu: { translation: eu },
  gl: { translation: gl }
};

// Check for entity language preference
const entityLang = typeof window !== 'undefined' ? localStorage.getItem('entity_language') : null;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: entityLang || undefined,
    fallbackLng: 'ca',
    supportedLngs: ['ca', 'es', 'eu', 'gl'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export const languages = [
  { code: 'ca', name: 'Català' },
  { code: 'es', name: 'Español' },
  { code: 'eu', name: 'Euskara' },
  { code: 'gl', name: 'Galego' }
];

export default i18n;
